import {PRIVILEGED_ROLES} from "../../../../../constants";

export const ADVANCED_CONTROL_ROLES = [...PRIVILEGED_ROLES, "field"];